import { motion } from "framer-motion";

const items = [
  "CBSE",
  "ICSE",
  "IB",
  "IGCSE",
  "State Boards",
  "Coaching Institutes",
  "Home-schoolers",
];

export default function TrustBar() {
  return (
    <section
      className="bg-off py-12 md:py-16"
      data-testid="trustbar-section"
    >
      <div className="mx-auto max-w-[1200px] px-5 md:px-8">
        {/* Highlighted card container */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.6 }}
          className="relative rounded-2xl md:rounded-[28px] bg-ink text-white-t overflow-hidden card-shadow"
          data-testid="trustbar-highlight"
        >
          {/* subtle accent line */}
          <div
            aria-hidden
            className="absolute inset-x-0 top-0 h-1 bg-accent"
          />
          <div className="px-6 md:px-10 lg:px-14 py-10 md:py-14 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-center">
            <div className="lg:col-span-6">
              <div className="text-[11px] md:text-[12px] uppercase tracking-[0.2em] text-white-t/70 font-semibold">
                A signature promise
              </div>
              <h3 className="mt-3 md:mt-4 font-display text-3xl sm:text-4xl md:text-[44px] leading-[1.05] tracking-tight text-white-t">
                Customised rubric for{" "}
                <span className="font-italic-serif text-accent">your school.</span>
              </h3>
              <p className="mt-4 md:mt-5 max-w-[46ch] text-[14px] md:text-[16px] leading-relaxed text-white-t/75">
                Your board, your school, your department, your teacher — every
                layer of your grading logic is preserved. ProBodh adapts to how
                you already teach.
              </p>
            </div>
            <div className="lg:col-span-6">
              <div className="text-[11px] md:text-[12px] uppercase tracking-[0.14em] text-white-t/55 font-semibold mb-4 md:mb-5">
                Works with
              </div>
              <div className="flex flex-wrap gap-2.5 md:gap-3">
                {items.map((label, i) => (
                  <motion.span
                    key={label}
                    initial={{ opacity: 0, y: 8 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: i * 0.05 }}
                    className="px-4 md:px-5 py-2 md:py-2.5 rounded-full bg-white-t/8 border border-white-t/20 text-[12px] md:text-[13px] font-semibold text-white-t"
                    style={{ background: "rgba(255,255,255,0.06)" }}
                    data-testid={`trust-chip-${label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {label}
                  </motion.span>
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
